const state= {};

const getters = {};

const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/mapping-report`, { params: params })
                .then(response => {
                    let items = [];
                    let key_report = {};
                    for (const [key, value] of Object.entries(response.data.data)) {
                        if(value.value == "n/a")
                            continue;
                        value.section = value.section.replace("<b>", "");
                        value.section = value.section.replace("</b>", "");

                        key_report[value.key] = value.full_section || value.section;
                        items.push(value);
                    }
                    resolve( {
                        data: items,
                        keys: key_report
                    } );
                })
                .catch(error => reject( error ));
        });
    },

    async exportItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/mapping-report/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
